import { CalendarPlus, MessageCircle, CheckCircle2 } from "lucide-react";
import { WHATSAPP_GROUP_LINK, GCAL_LINK } from "@/config";
import { SESSION } from "@/config/session";

export const Confirmation = ({ name }) => (
  <div className="text-center" data-testid="ty-confirmation">
    <div className="mx-auto w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-green-500 grid place-items-center shadow-[0_18px_40px_-12px_rgba(22,163,74,0.6)] ty-pop">
      <CheckCircle2 className="w-12 h-12 sm:w-14 sm:h-14 text-white" strokeWidth={2.4} />
    </div>
    <h1 className="font-black text-ink text-[28px] sm:text-4xl lg:text-5xl mt-6 leading-tight" data-testid="ty-headline">
      {name ? `You're In, ${name}!` : "You're In!"} <span aria-hidden>🎉</span>
    </h1>
    <p className="text-zinc-700 text-[14.5px] sm:text-base mt-4 max-w-xl mx-auto leading-relaxed">
      Your seat for <span className="font-bold text-ink">The Wealth Code Masterclass</span> is confirmed.
    </p>
    <p className="mt-3 inline-block rounded-full bg-white border border-[#5B2BD6]/15 text-[#5B2BD6] font-semibold text-[13px] sm:text-sm px-4 py-2" data-testid="ty-event-details">
      {SESSION.dateLabel} · {SESSION.startTime} IST · Live on Zoom
    </p>
  </div>
);

const StepCard = ({ n, title, children, highlight }) => (
  <div className={`relative rounded-2xl bg-white p-5 sm:p-6 ${highlight ? "border-2 border-green-500 shadow-[0_24px_50px_-28px_rgba(22,163,74,0.7)]" : "border border-[#5B2BD6]/10 shadow-[0_18px_40px_-28px_rgba(42,15,92,0.5)]"}`} data-testid={`ty-step-${n}`}>
    <div className="flex items-center gap-3 mb-3">
      <span className={`w-9 h-9 shrink-0 rounded-full grid place-items-center font-black text-white ${highlight ? "bg-green-600" : "bg-[#5B2BD6]"}`}>{n}</span>
      <h2 className="font-extrabold text-ink text-[17px] sm:text-xl">{title}</h2>
      {highlight && <span className="ml-auto text-[11px] font-bold uppercase tracking-wider text-green-700 bg-green-100 rounded-full px-2.5 py-1">Must do</span>}
    </div>
    {children}
  </div>
);

export const NextSteps = () => (
  <div className="grid gap-4 max-w-xl mx-auto mt-10" data-testid="ty-steps">
    <StepCard n={1} title="Join the WhatsApp Group" highlight>
      <p className="text-[14px] text-zinc-700 mb-4">The Zoom link and reminders are shared <span className="font-bold text-ink">ONLY</span> there.</p>
      <a href={WHATSAPP_GROUP_LINK} target="_blank" rel="noopener noreferrer" data-testid="join-whatsapp-button"
        className="wa-btn cta-pulse-green flex items-center justify-center gap-2.5 w-full rounded-2xl py-4 text-white font-extrabold text-base sm:text-lg transition-transform hover:-translate-y-0.5 active:scale-[0.98]">
        <MessageCircle className="w-6 h-6" /> Join the WhatsApp Group
      </a>
    </StepCard>
    <StepCard n={2} title="Add to Google Calendar">
      <p className="text-[14px] text-zinc-700 mb-4">Block {SESSION.shortLabel}, {SESSION.timeLabel} so you don't miss it.</p>
      <a href={GCAL_LINK} target="_blank" rel="noopener noreferrer" data-testid="add-to-calendar-link"
        className="flex items-center justify-center gap-2 w-full rounded-2xl py-3.5 border-2 border-[#5B2BD6] text-[#5B2BD6] font-bold text-[15px] hover:bg-[#5B2BD6] hover:text-white transition-colors">
        <CalendarPlus className="w-5 h-5" /> Add to Google Calendar
      </a>
    </StepCard>
  </div>
);
